import { NotificationOffIcon } from "vega-icons";

import { m } from "@vega-core/paraglide/messages";

type Props = {
  title?: string;
  description?: string;
};

export const NotificationCenterEmptyState = ({
  title = m.notificationCenter_emptyTitle(),
  description = m.notificationCenter_emptyDescription(),
}: Props) => (
  <div
    className="flex flex-col items-center justify-center text-center py-10 px-6 gap-2"
    data-testid="notification-center-empty"
  >
    <NotificationOffIcon
      aria-hidden="true"
      className="h-8 w-8 text-text/secondary"
    />
    <p className="body-base-semibold text-text/primary">{title}</p>
    <p className="body-small-regular text-text/secondary">{description}</p>
  </div>
);
